import cn from 'classnames';
import React from 'react';
import { Logo } from 'src/components/logo';
import { PopupLearnMoreClose } from 'src/components/popup-learn-more-close';
import { Text } from 'src/components/text/Text';

import styles from './PopupLearnMoreBackgroundHeader.css';

export type HeroVariant = 'default' | 'pay-next-month';

interface Props {
  title: string;
  subtitle: React.ReactNode;
  onClose?: () => void;
  heroVariant?: HeroVariant;
}

export const PopupLearnMoreBackgroundHeader = ({
  title,
  subtitle,
  onClose,
  heroVariant = 'default',
}: Props) => {
  return (
    <div
      className={styles.PopupLearnMoreBackgroundHeader}
      data-testid="learn-more-popup-background-header"
    >
      <div className={styles.PopupLearnMoreBackgroundHeader__Header}>
        <Logo
          color="black on transparent"
          className={styles.PopupLearnMoreBackgroundHeader__Logo}
        />
        {!!onClose && (
          <div className={styles.PopupLearnMoreBackgroundHeader__Close}>
            <PopupLearnMoreClose
              onClose={onClose}
              className={styles.PopupLearnMoreBackgroundHeader__CloseIcon}
            />
          </div>
        )}
      </div>

      <div
        className={cn(styles.PopupLearnMoreBackgroundHeader__Hero, {
          [styles.PopupLearnMoreBackgroundHeader__Hero_payNextMonth]:
            heroVariant === 'pay-next-month',
        })}
        data-test="popup-header-hero"
        data-hero-variant={heroVariant}
      />
      <div className={styles.PopupLearnMoreBackgroundHeader__Content}>
        <Text as="h1" variant="h1" data-test="popup-header-title">
          {title}
        </Text>
        <Text as="p" variant="body2Tight" data-test="popup-header-subtitle">
          {subtitle}
        </Text>
      </div>
    </div>
  );
};
